import React from "react";
import "./style.css";

export default function App() {
  return (
    <div>
      <h1>سلام دنیااااااااااااا
	  </h1>
      <p>Start editing to see some magic happen :)</p>
    </div>
  );
}
